import { ClientInferRequest, ClientInferResponseBody } from "@ts-rest/core";

import { contract } from "#app/http/api";
import { api } from "#app/http/api";
import { ApiError } from "#shared/infra/apiError";

export type Add2dFileResponse = ClientInferResponseBody<
  typeof contract.quoteRequestLines.add2dFile
>;

export type Add2dFileDto = ClientInferRequest<typeof contract.quoteRequestLines.add2dFile>["body"];

export const add2dFile = async ({
  quoteRequestLineId,
  payload,
}: {
  quoteRequestLineId: string;
  payload: Add2dFileDto;
}): Promise<Add2dFileResponse> => {
  const response = await api.quoteRequestLines.add2dFile.mutation({
    body: payload,
    params: { id: quoteRequestLineId },
  });

  if (response.status === 200) {
    return response.body;
  }

  throw new ApiError(
    "Failed to delete quote request line surface treatments",
    response.status,
    response.body,
  );
};
